import { createRouter, createWebHistory } from 'vue-router'

export const routes = [
    {
        path: '/lxjsadmin/login',
        component: () => import('@/views/admin/Login.vue'),
        meta: {
            requiresAuth: false,
            noLayout: true
        }
    },
    {
        path: '/lxjsadmin',
        component: () => import('@/layouts/AdminLayout.vue'),
        meta: {
            requiresAuth: true
        },
        children: [
            // RBAC routes
            {
                path: 'users',
                component: () => import('@/views/admin/Users.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'tutorials',
                component: () => import('@/views/admin/Tutorials.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'tutorials/:id',
                component: () => import('@/views/admin/TutorialContent.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'accounts',
                component: () => import('@/views/admin/AccountManagement.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'keys',
                component: () => import('@/views/admin/KeyManagement.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'partners',
                component: () => import('@/views/admin/Partners.vue'),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'commission-ranking',
                component: () => import('@/views/admin/CommissionRanking.vue'),
                meta: {
                    requiresAuth: true
                }
            }
        ]
    }
]

export const history = createWebHistory('/')

export const guards = [
    async (to) => {
        if (to.meta.requiresAuth) {
            const { isLoggedIn } = await import('@/utils/auth')
            const { isMainAccount } = await import('@/utils/permission')
            const response = await isLoggedIn()
            
            if (!response.success) {
                return '/lxjsadmin/login'
            }
            
            const adminOnlyPaths = ['/lxjsadmin/users', '/lxjsadmin/accounts', '/lxjsadmin/keys', '/lxjsadmin/partners', '/lxjsadmin/commission-ranking']
            
            if (adminOnlyPaths.some(path => to.path.startsWith(path)) && !isMainAccount()) {
                return '/lxjsadmin/tutorials'
            }
            
            return true
        }
        return true
    }
]

const router = createRouter({ history, routes })
export default router
